"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfErrorOutput = instanceOfErrorOutput;
exports.ErrorOutputFromJSON = ErrorOutputFromJSON;
exports.ErrorOutputFromJSONTyped = ErrorOutputFromJSONTyped;
exports.ErrorOutputToJSON = ErrorOutputToJSON;
/**
 * Check if a given object implements the ErrorOutput interface.
 */
function instanceOfErrorOutput(value) {
    if (!('errors' in value) || value['errors'] === undefined)
        return false;
    return true;
}
function ErrorOutputFromJSON(json) {
    return ErrorOutputFromJSONTyped(json, false);
}
function ErrorOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'errors': json['errors'],
    };
}
function ErrorOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'errors': value['errors'],
    };
}
